import React, { useState, useEffect, useRef } from "react";
import Button from "react-bootstrap/Button";
import Modal from "react-bootstrap/Modal";
import Form from "react-bootstrap/Form";
import ModalHeader from "../../../common/ModalHeader";
import ModalFooter from "../../../common/ModalFooter";
import ModalBody from "../../../common/ModalBody";
import { useTranslation } from "react-i18next";
import Constants from "../../../../common/Constants";

const CustomersModal = (props) => {
  let [name, setName] = useState("");
  let [edit, setEdit] = useState(false);
  let [id, setId] = useState("");
  let [email, setEmail] = useState("");
  let [address, setAddress] = useState("");
  const [validate, setValidate] = useState(false);
  let [status, setStatus] = useState("Active");
  const { t } = useTranslation();
  const formRef = useRef(null);

  useEffect(() => {
    if (props.data.customerCode) {
      setName(props?.data?.customerName);
      setId(props?.data?.customerCode);
      setStatus(props?.data?.customerStatus);
      setEmail(props?.data?.customerEmail);
      setAddress(props?.data?.customerAddress);
      setEdit(true);
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handleSave = (event) => {
    const form = formRef.current;
    if (form.checkValidity() === false) {
      event.preventDefault();
      event.stopPropagation();
      setValidate(true);
      return;
    } else {
      setValidate(false);
      const custObj = {
        customerName: name,
        customerCode: id,
        customerEmail: email,
        customerAddress: address,
        customerStatus: status,
      };
      if (edit) {
        custObj._id = props.data._id;
      }
      props.onSave(custObj, edit);
      setName("");
      setId("");
      setEdit(false);
    }
  };

  const handleCancel = (event) => {
    setName("");
    setId("");
    props.onHide();
  };

  const { show, onHide } = props;
  return (
    <Modal show={show} onHide={onHide} animation={false} backdrop="static">
      <ModalHeader
        title={edit? t("msg_master_list.msg_customer.edit_page_title"): t("msg_master_list.msg_customer.page_title")}
      ></ModalHeader>
      <ModalBody>
        <Form noValidate validated={validate} ref={formRef}>
          <Form.Group className="mb-3" controlId="exampleForm.ControlInput1">
            <Form.Label className="col-form-label">
              {t("msg_master_list.msg_customer.code")} :
            </Form.Label>
            <Form.Control
              type="text"
              placeholder="e.g: CUST-001"
              value={id || ""}
              onChange={(e) => setId(e.target.value?.trim()?.toUpperCase())}
              required
              maxLength={Constants.MASTER.VALIDATION.maxLengthCode}
              autoFocus
            />
            <Form.Control.Feedback type="invalid">
              {t("msg_master_list.msg_customer.customer_code_validation")}
            </Form.Control.Feedback>
          </Form.Group>
          <Form.Group className="mb-3" controlId="exampleForm.ControlInput1">
            <Form.Label className="col-form-label">
              {" "}
              {t("msg_master_list.msg_customer.customer_name")} :
            </Form.Label>
            <Form.Control
              type="text"
              value={name || ""}
              onChange={(e) => setName(e.target.value)}
              maxLength={Constants.MASTER.VALIDATION.maxLengthName}
              required
            />
            <Form.Control.Feedback type="invalid">
              {t("msg_master_list.msg_customer.customer_name_validation")}
            </Form.Control.Feedback>
          </Form.Group>
          <Form.Group className="mb-3" controlId="exampleForm.ControlInput1">
            <Form.Label className="col-form-label">
              {t("msg_master_list.msg_customer.email")} :
            </Form.Label>
            <Form.Control
              type="email"
              placeholder="e.g: name@example.com"
              value={email || ""}
              onChange={(e) => setEmail(e.target.value.trim())}
              isInvalid={validate && !/^\S+@\S+\.\S+$/.test(email)}
              required
              autoFocus
            />
            <Form.Control.Feedback type="invalid">
              {t("msg_master_list.msg_customer.customer_email_validation")}
            </Form.Control.Feedback>
          </Form.Group>
          <Form.Group className="mb-3" controlId="exampleForm.ControlInput1">
            <Form.Label className="col-form-label">
              {t("msg_master_list.msg_customer.address")} :
            </Form.Label>
            <Form.Control
              as="textarea"
              value={address || ""}
              rows={2}
              onChange={(e) => setAddress(e.target.value)}
              required
              autoFocus
            />
            <Form.Control.Feedback type="invalid">
              {t("msg_master_list.msg_customer.customer_address_validation")}
            </Form.Control.Feedback>
          </Form.Group>
          <Form.Group className="mb-3" controlId="exampleForm.ControlInput1">
            <Form.Label className="col-form-label">
              {t("msg_common.status")} :
            </Form.Label>
            <Form.Select
              aria-label="select status"
              value={status}
              onChange={(e) => setStatus(e.target.value)}
            >
              <option value="Active">{t("msg_common.active")}</option>
              <option value="Inactive">{t("msg_common.inactive")}</option>
            </Form.Select>
          </Form.Group>
        </Form>
      </ModalBody>
      <ModalFooter>
        <Button
          type="button"
          variant="success"
          className="btn btn-success"
          onClick={handleSave}
        >
          {t("msg_common.save")}
        </Button>
        <Button
          type="button"
          variant="danger"
          className="btn btn-danger"
          onClick={handleCancel}
          data-dismiss="modal"
        >
          {t("msg_common.cancel")}
        </Button>
      </ModalFooter>
    </Modal>
  );
};

export default CustomersModal;
